import SimpleBar from 'simplebar';
import 'simplebar/dist/simplebar.css';

/**
 * Class Add Breadcrumb.
 */
export default class Breadcrumb {
  private breadcrumbElement: HTMLElement = document.querySelector(
    '.c-breadcrumb__container'
  );

  constructor() {
    if (this.breadcrumbElement) {
      new SimpleBar(this.breadcrumbElement);
    }
  }
}
